/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
let CharactersCounter = (function () {
    let getCount = function (field) {
        return field.val().length || 0;
    };

    let getField = function (counter) {
        let fieldName = $(counter).data('field-name');
        return $('textarea[name="' + fieldName + '"]');
    };

    let updateCount =  function (counter, field) {
        let count = getCount(field);
        counter.html(count);
    };

    let setCounter = function (counter, field) {
        field.on('keyup', function () {
            updateCount(counter, field);
        });
    };

    let init = function () {
        $('.characters-count').each(function (i, counter) {
            let field = getField($(counter));

            if (field.length) {
                setCounter($(counter), field);
                updateCount($(counter), field);
            }
        });
    };

    return {
        init: init
    };
})();

export default CharactersCounter;
